export default __webpack_public_path__ + "static/media/UndoIcon.b64155d3.svg";